import { render, staticRenderFns } from "./merchantClassification.vue?vue&type=template&id=188e4bca&scoped=true&"
import script from "./merchantClassification.vue?vue&type=script&lang=js&"
export * from "./merchantClassification.vue?vue&type=script&lang=js&"
import style0 from "./merchantClassification.vue?vue&type=style&index=0&id=188e4bca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188e4bca",
  null
  
)

export default component.exports